export default __webpack_public_path__ + "static/media/grafema_the-creativity-virus_12.44a1fb2d.jpg";